export default __webpack_public_path__ + "static/media/element_62.d9360a7d.webp";